import angular from 'angular';
import moment from 'moment';
import { IApontamentoImportacaoArquivo } from '../models/apontamentosimportacao.model';
import { OperacaoApontamentosImportacaoEnum } from '../enums/operacao';

export class ApontamentosImportacaoModalController {

    static $inject = [
        '$uibModalInstance',
        '$rootScope',
        '$scope',
        'entity',
        'NewToaster'
    ];

    public operacaoEnum = OperacaoApontamentosImportacaoEnum;
    public form: angular.IFormController;
    public isFileValid = false;
    public selectCompetencias = this.setSelects();

    constructor(
        public $uibModalInstance: ng.ui.bootstrap.IModalInstanceService,
        public $rootScope: angular.IRootScopeService & { configuracoes: { [key: string]: unknown } },
        public $scope: angular.IScope,
        public entity: IApontamentoImportacaoArquivo,
        public NewToaster: { pop: Function }
    ) {
        if (!this.entity.competencia.ano && !this.entity.competencia.mes) {
            this.entity.competencia = {
                ano: this.selectCompetencias.anoMaisRecente,
                mes: this.selectCompetencias.meses[this.selectCompetencias.meses.length - 1]
            };
        }
    }

    getLimitDate() {
        const currentDate = moment().startOf('day');
        const competencia = moment(this.$rootScope.configuracoes.DATA_FECHAMENTO_FOLHA, 'YYYY-MM-DD');

        if (currentDate.isAfter(competencia)) {
            currentDate.add(1, 'month');
        }
        return currentDate;
    }

    setSelects() {
        const limitDate = this.getLimitDate();

        return {
            anoMaisRecente: limitDate.year(),
            anoMaisAntigo: limitDate.year() - 11,
            meses: this.setMonths(limitDate.year())
        };
    }

    setMonths(year: number) {
        const limitDate = this.getLimitDate();

        if (year < limitDate.year()) {
            return Array.from({ length: 12 }, (_, index) => index + 1);
        }

        return Array.from({ length: limitDate.month() + 1 }, (_, index) => index + 1);
    }

    setSelectMonths(year: number) {
        this.entity.competencia.mes = undefined;
        this.selectCompetencias.meses = this.setMonths(year);
    }

    fileTypeValidation() {
        const allowedExtensions = /\.(xls|xlsx|csv)$/i;
        if (!allowedExtensions.exec(this.entity.file[0].name)) {
            this.NewToaster.pop({
                type: 'error',
                title: 'Tipo de arquivo inválido',
                body: 'O tipo do arquivo deve ser .xls, .xlsx ou .csv',
            });
            this.isFileValid = false;
            this.entity.file = {} as FileList;
        } else {
            this.isFileValid = true;
        }
        this.$scope.$applyAsync();
    }

    formatBytes(bytes: number, decimals: number = 2) {
        if (bytes === 0) {
            return '0 Bytes';
        }

        const k = 1024;
        const dm = decimals < 0 ? 0 : decimals;
        const sizes = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB', 'ZB', 'YB'];

        const i = Math.floor(Math.log(bytes) / Math.log(k));

        return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i];
    }

    submit() {
        if (!this.isFileValid || this.form.$invalid) {
            return;
        }
        this.$uibModalInstance.close(this.entity);
    }

    close() {
        this.$uibModalInstance.dismiss('cancelar');
    }
}
